import { Card, ThemeProvider } from "@mui/material";
import { keepPreviousData } from "@tanstack/react-query";
import LoadingScreen from "components/loading/LoadingScreen";
import Table from "components/table/Table";
import { ALL_OPTION, CALL_TIME_OPTIONS } from "constant";
import { usePagination } from "hooks/usePagination";
import moment from "moment";
import ReportSynthesisFailedCallFilter from "pages/reports/report-synthesis-failed-call/components/ReportSynthesisFailedCallFilter";
import { useMemo, useState } from "react";
import {
  useExportReportSynthesisFailedCall,
  useGetReportSynthesisFailedCall,
} from "service/query/report.query";
import muiTheme from "theme/muiTheme";

const ReportSynthesisFailedCall = () => {
  const [filter, setFilter] = useState(null);
  const { data: reportSynthesisFailedCall, isFetching } =
    useGetReportSynthesisFailedCall(
      {
        ...filter,
      },
      {
        enabled: !!filter,
        placeholderData: keepPreviousData,
      }
    );
  // phân trang client
  const {
    page,
    pageSize,
    handleChangePage,
    handleChangePageSize,
    clientData,
    clientTotal,
  } = usePagination(reportSynthesisFailedCall);

  const handleSubmit = (values) => {
    const from = moment(values.dateRange[0]).toISOString();
    const to = moment(values.dateRange[1]).toISOString();

    // Ban đầu ALL nên tất cả giá trị value = null
    // Check chỉ gửi điều kiện nhỏ nhất lên
    let valueCityCode = null;
    let valueDistrict = null;
    let valueSubOrg = null;

    if (
      values.cityCode !== ALL_OPTION.value &&
      values.district === ALL_OPTION.value &&
      values.subOrg === ALL_OPTION.value
    ) {
      valueCityCode = values.cityCode;
    }
    if (
      values.cityCode !== ALL_OPTION.value &&
      values.district !== ALL_OPTION.value &&
      values.subOrg === ALL_OPTION.value
    ) {
      valueDistrict = values.district;
    }

    if (
      values.cityCode !== ALL_OPTION.value &&
      values.district !== ALL_OPTION.value &&
      values.subOrg !== ALL_OPTION.value
    ) {
      valueSubOrg = values.subOrg;
    }

    setFilter({
      cityCode: valueCityCode,
      district: valueDistrict,
      subOrg: valueSubOrg,
      typePbx: values.typePbx === ALL_OPTION.value ? null : values.typePbx,
      groupBy: values.groupBy === ALL_OPTION.value ? null : values.groupBy,
      callTime:
        values.callTime === CALL_TIME_OPTIONS[0].value ? null : values.callTime,
      extensions: values.extensions || null,
      from,
      to,
    });

    handleChangePage(1);
  };

  const columns = useMemo(
    () => [
      {
        id: "code",
        name: "Mã đơn vị",
      },
      {
        id: "name",
        name: "Tên đơn vị",
      },
      {
        id: 1,
        name: "Số cuộc gọi ra",
        align: "center",
        children: [
          {
            id: "totalOutboundCall",
            name: "Tổng cuộc gọi",
          },
          {
            id: "totalFailedOutboundCall",
            name: "Cuộc gọi kết nối thất bại",
          },
          {
            id: "totalConnectedOutboundCall",
            name: "Cuộc gọi kết nối thành công",
          },
          {
            id: "totalFailedOutboundCallByUser",
            name: "Số cuộc gọi lỗi do thao tác người dùng",
          },
          {
            id: "totalFailedOutboundCallByExtension",
            name: "Số cuộc gọi lỗi kết nối máy lẻ",
          },
          {
            id: "totalFailedOutboundCallByPbx",
            name: "Số cuộc gọi bị lỗi do Tổng đài",
          },
        ],
      },
      {
        id: "rateFailedOutboundCallByPbx",
        name: "Tỉ lệ cuộc gọi ra bị lỗi do Tổng đài so với Tổng cuộc gọi ra",
      },

      {
        id: 2,
        name: "Số cuộc gọi vào",
        align: "center",
        children: [
          {
            id: "totalConnectedInboundCall",
            name: "Tổng cuộc gọi vào kết nối thành công",
          },
          {
            id: "totalFailedInboundCall",
            name: "Tổng cuộc gọi vào kết nối thất bại",
          },
          {
            id: "totalFailedInboundCallByPbx",
            name: "Cuộc gọi lỗi Tổng đài",
          },
          {
            id: "totalFailedInboundCallByQueue",
            name: "Cuộc gọi không tìm thấy hàng đợi",
          },
          {
            id: "rateFailedInboundCall",
            name: "Tỷ lệ cuộc gọi vào kết nối thất bại",
          },
        ],
      },
    ],
    []
  );

  // const { refetch: handleExport, isFetching: isFetchingExport } =
  //   useExportDetailOutboundCall(filter, null, modalExportHistories.openModal);
  const { refetch: handleExport, isFetching: isFetchingExport } =
    useExportReportSynthesisFailedCall(
      {
        ...filter,
        isExport: true,
      },
      { enabled: false }
    );

  return (
    <ThemeProvider theme={muiTheme}>
      <Card sx={{ mb: 2 }}>
        <ReportSynthesisFailedCallFilter
          onSubmit={handleSubmit}
          onExport={handleExport}
          isDisabledExport={!filter}
        />
      </Card>

      <Card>
        <Table
          columns={columns}
          data={clientData}
          toolbar={{
            title: "Danh sách tổng hợp cuộc gọi lỗi",
            // onViewHistories: modalExportHistories.openModal,
          }}
          pagination={{
            page,
            pageSize,
            totalItems: clientTotal,
            onPageChange: handleChangePage,
            onPageSizeChange: handleChangePageSize,
          }}
        />
      </Card>

      <LoadingScreen loading={isFetching || isFetchingExport} />
    </ThemeProvider>
  );
};

export default ReportSynthesisFailedCall;
